module.exports = __webpack_public_path__ + "assets/spotify.fb42be87.svg";